import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import { LAYER_ONE } from "constants/z-index";
import { BLACK_COLOR_NAME } from "styles/color-consts";
import { getComponentShadowFilter } from "segments/desktop/constants";
import colors from "styles/colors";

const CARD_WIDTH = 286;
const CARD_BORDER_RADIUS = 8;
const CARD_HORIZONRAL_PADDING = 20;
const CARD_IMAGE_HEIGHT = 100;

export const componentStyles = css`
  .review-cards-reviews-component {
    max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
    margin: auto;

    :global(.full-paragraph-component .full-paragraph-wrapper) {
      max-width: unset;
    }
    .cards {
      margin: auto;
      display: flex;
      justify-content: center;
      text-align: center;
      .card {
        width: ${`${CARD_WIDTH}px`};
        z-index: ${LAYER_ONE};
        margin: 32px 10px 0;
        padding: 32px ${`${CARD_HORIZONRAL_PADDING}px`} 32px;
        border-radius: ${`${CARD_BORDER_RADIUS}px`};
        background-color: white;
        filter: ${getComponentShadowFilter(0.16)};
        transition: filter 0.2s ease-in-out;
        color: ${colors[BLACK_COLOR_NAME]};
        position: relative;

        &:hover {
          filter: ${getComponentShadowFilter(0.32)};
        }

        // remove hover effect in safari because of this bug: https://monday.monday.com/boards/757661511/pulses/2181485781
        @media not all and (min-resolution: 0.001dpcm) {
          @supports (-webkit-appearance: none) {
            &:hover {
              filter: ${getComponentShadowFilter(0.16)};
            }
          }
        }

        .top-image {
          align-items: center;
          justify-content: center;
          display: flex;
          margin-bottom: 16px;
          height: ${`${CARD_IMAGE_HEIGHT}px`};
          :global(img) {
            max-height: ${`${CARD_IMAGE_HEIGHT}px`};
            max-width: ${`${CARD_WIDTH - CARD_HORIZONRAL_PADDING * 4}px`};
          }
        }

        .title {
          font-size: 20px;
          line-height: 24px;
          letter-spacing: -0.5px;
          font-weight: 500;
          margin-bottom: 24px;
          min-height: 64px;
        }

        .subtitle {
          font-size: 18px;
          line-height: 24px;
        }
      }
    }
  }
`;
